<script>
  import Navbar from "./common/navbar.svelte";
  import Quote from "./quote.svelte";

  import Footer from "./common/footer.svelte";
  import Branding from "./common/branding.svelte";

  export let currentRoute: any;
</script>

<Navbar />
<Quote {currentRoute} />
<Footer />
<Branding />

<style lang="scss">
</style>
